var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 342,
    viewBox: "0 0 513 342",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -0.00537109H513V341.998H0V-0.00537109Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 341.99V-0.010376H513",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 311.762V341.99H45.3434L513 30.2185V-0.010376H467.657L0 311.762Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8554 23.4934L90.9854 39.2802H107.584L94.1545 49.0362L99.2845 64.824L85.8554 55.0669L72.4242 64.824L77.5542 49.0362L64.125 39.2802H80.7244L85.8554 23.4934ZM170.645 23.4934L175.776 39.2802H192.375L178.946 49.0362L184.076 64.824L170.645 55.0669L157.215 64.824L162.345 49.0362L148.916 39.2802H165.515L170.645 23.4934ZM85.8554 106.157L90.9854 121.943H107.584L94.1545 131.7L99.2845 147.488L85.8554 137.73L72.4242 147.488L77.5542 131.7L64.125 121.943H80.7244L85.8554 106.157ZM170.645 106.157L175.776 121.943H192.375L178.946 131.7L184.076 147.488L170.645 137.73L157.215 147.488L162.345 131.7L148.916 121.943H165.515L170.645 106.157ZM128.25 64.824L133.38 80.6107H149.98L136.549 90.3678L141.679 106.157L128.25 96.3985L114.821 106.157L119.951 90.3678L106.52 80.6107H123.12L128.25 64.824Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 -0.00634766)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSb);
export default __webpack_public_path__ + "static/media/SB.7db0701ee4b26c34dc185c6abeed70d4.svg";
export { ForwardRef as ReactComponent };